var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreloader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#fff",
    transform: "translate(30,30) rotate(108) scale(1.3,0) translate(-30,-30)",
    style: {
      animation: "3s linear infinite both a0_t"
    }
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(30px,30px) rotate(108deg) scale(1.3,0) translate(-30px,-30px); animation-timing-function: cubic-bezier(.5,0,.5,1); } 50% { transform: translate(30px,30px) rotate(108deg) scale(1.3,1) translate(-30px,-30px); animation-timing-function: cubic-bezier(.5,0,.5,1); } 100% { transform: translate(30px,30px) rotate(108deg) scale(1.3,0) translate(-30px,-30px); } }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 36l-1.9 5.2h8.6l3.2-4l-8.4 22.8h6.1l6.9-18.8h10.3l1.9-5.2h-26.7Z",
    fill: "#bfc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4 36l-6.9 18.9l.4-5.3l-10.5-13.6h-5.1l-8.8 24h6.2l5.5-14.9l11.5 14.9h5.2l8.7-24h-6.2Z",
    fill: "#bfc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.4 33.4h13.6l2.3-9.6l-2.9-3.7l1.2-3.9l5.5-8.3l2.4 2.9l-1.6 2.6l2 7.1l-8.9 12.9h24.7l-8.5-6.6l1.9-5.1l-4.2-6.6l3.4-6.1l-0.8-6.7l5.1 14.8l6.9 3.9l-3.8 12.4h21.3l-14.8-28.4l-3.9 6.7l-4.3-4.6l-2.1 .9l-4.7-8l-7 9.5l-3-3.6l-7.9 8.8l-5 2l-6.9 16.7Zm45.1-10.8l-0.8-6.2l1.8-3.3l-2.7-2.5l1.4-2.7l5.1 10l-1.2 4.1l5.5 11.4l-9.1-10.8Z",
    fill: "#bfc0cb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9 36l-1.9 5.2h8.6l3.2-4l-8.4 22.8h6.1l6.9-18.8h10.3l1.9-5.2h-26.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4 36l-6.9 18.9l.4-5.3l-10.5-13.6h-5.1l-8.8 24h6.2l5.5-14.9l11.5 14.9h5.2l8.7-24h-6.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.4 33.4h13.6l2.3-9.6l-2.9-3.7l1.2-3.9l5.5-8.3l2.4 2.9l-1.6 2.6l2 7.1l-8.9 12.9h24.7l-8.5-6.6l1.9-5.1l-4.2-6.6l3.4-6.1l-0.8-6.7l5.1 14.8l6.9 3.9l-3.8 12.4h21.3l-14.8-28.4l-3.9 6.7l-4.3-4.6l-2.1 .9l-4.7-8l-7 9.5l-3-3.6l-7.9 8.8l-5 2l-6.9 16.7Zm45.1-10.8l-0.8-6.2l1.8-3.3l-2.7-2.5l1.4-2.7l5.1 10l-1.2 4.1l5.5 11.4l-9.1-10.8Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloader);
export default __webpack_public_path__ + "static/media/preloader_.ab632686e1120ae61b4f599ae6c36418.svg";
export { ForwardRef as ReactComponent };